import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DealFilterEffects } from './deal-filter.effects';
import { initialState, reducer } from './deal-filter.reducer';
import { DealFilterState } from './deal-filter.state';
import { getEnvironment } from '../../features/shared/utils/get-environment';
import { createLocalStorageSyncReducer } from '../local-storage-sync';

const syncSessionStorageMetaReducer = createLocalStorageSyncReducer<DealFilterState>({
  keys: ['appliedFilter', 'selectedFilterId'],
  rehydrate: true,
  storage: sessionStorage,
  storageKeySerializer: (key) => `semeris-${getEnvironment()}-${key}`,
});

const syncLocalStorageMetaReducer = createLocalStorageSyncReducer<DealFilterState>({
  keys: ['modeLookup'],
  rehydrate: true,
  storage: localStorage,
  storageKeySerializer: (key) => `semeris-${getEnvironment()}-deal-filter-${key}`,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('dealFilter', reducer, {
      initialState,
      metaReducers: [syncSessionStorageMetaReducer, syncLocalStorageMetaReducer],
    }),
    EffectsModule.forFeature([DealFilterEffects]),
  ],
  providers: [DealFilterEffects],
})
export class DealFilterStoreModule {}
